import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { FeaturesById } from '../../../map/DrawControl';
import { MapDrawIDEnum } from '../../onboardingSlice';
import { isValidGeoFeature } from '../../onboardingUtils';
import { BlockBoundaryAndOrientationSubmitButton } from './BlockBoundaryAndOrientationSubmitButton';
import ClearMapDrawFeaturesButton from './ClearMapDrawFeaturesButton';
import CustomTitleDivider from './CustomTitleDivider';

interface Props {
  handleSendBlockBoundaryClick: (type: 'draw' | 'upload') => Promise<void>;
  currMapDrawFeatures: FeaturesById;
}

const StyledBox = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const BlockBoundaryFormTabDrawSection: React.FC<Props> = ({
  handleSendBlockBoundaryClick,
  currMapDrawFeatures,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        p: '0.5rem',
        border: (theme) => `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: (theme) => theme.borderRadius.primary,
        display: 'grid',
        gridTemplateRows: 'min-content min-content 1fr min-content min-content',
        gridTemplateColumns: '1fr',
      }}
    >
      <StyledBox>
        <Typography
          variant='h5'
          sx={{ color: (theme) => theme.colors.common.bloomfieldGreen }}
        >
          {t('Draw', { ns: 'common' })}
        </Typography>
      </StyledBox>

      <CustomTitleDivider />
      <StyledBox>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            flexDirection: 'column',
            p: 2,
          }}
        >
          <Typography variant='body1'>
            {`1. ${t('Select the polygon tool on the map.', {
              ns: 'common',
            })}`}
          </Typography>
          <Typography variant='body1'>
            {`2. ${t('Draw the new boundary.', { ns: 'common' })}`}
          </Typography>
          <Typography variant='body1'>
            {`3. ${t('Press "Enter" on your keyboard when done.', {
              ns: 'common',
            })}`}
          </Typography>
          <Typography variant='body1'>
            {`4. ${t('Press the "Submit" Button.', { ns: 'common' })}`}
          </Typography>
        </Box>
      </StyledBox>
      <StyledBox sx={{ gap: '0.5rem' }}>
        <ClearMapDrawFeaturesButton />
        <BlockBoundaryAndOrientationSubmitButton
          onClick={() => handleSendBlockBoundaryClick('draw')}
          disabled={
            !isValidGeoFeature(
              currMapDrawFeatures,
              'Polygon',
              MapDrawIDEnum.blockBoundary
            )
          }
        />
      </StyledBox>
    </Box>
  );
};

export default BlockBoundaryFormTabDrawSection;
